import { createTradePartnerValueParser, parsePastedDate } from 'shared/lib/datagridHelpers';

export const formatMismatchMessage = (label) =>
    `"${label}" - pasted value doesn't match this field's format; ignored.`;

/**
 * Client column: turns a pasted name back into a trade-partner object.
 */
export const createClientPasteParser = ({ options, onMismatch }) => {
    const resolvePartner = createTradePartnerValueParser('il_trade_partner', options);

    return (value, row, column, apiRef) => {
        const parsed = resolvePartner(value, row, column, apiRef);
        const pastedText = typeof value === 'string' ? value.trim() : '';
        // A resolved name comes back unchanged — anything else means we could not recognize it
        if (pastedText && parsed?.name !== pastedText) {
            onMismatch?.('Client');
        }
        return parsed;
    };
};

/** Date column: rejects unreadable text (an empty value legitimately clears the date). */
export const createDatePasteParser = ({ label, onMismatch }) => (value) => {
    const parsed = parsePastedDate(value);
    if (parsed === undefined) {
        onMismatch?.(label);
        return undefined;
    }
    return parsed;
};

/** Fee column: rejects non-numeric or negative values — fees are amounts paid, so a
 *  minus amount pasted from Excel must not be stored (the server refuses it too). */
export const createNumberPasteParser = ({ label, onMismatch }) => (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    const numeric = Number(String(value).replace(/[$,\s]/g, ''));
    if (!Number.isFinite(numeric) || numeric < 0) {
        onMismatch?.(label);
        return undefined;
    }
    return numeric;
};
